<template>
  <div>
    <FormStepInputs
      :step="{
        stepName: name,
        formInputs: content,
      }"
    >
      <template #yourProducts>
        <div data-test-id="product_list_component">
          <ProductCardList
            :hideInsurance="true"
            :hideBank="true"
            :fields="yourProducts"
            :portfolio="accountStore.identityDetails?.portfolio"
          />
        </div>
      </template>
    </FormStepInputs>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { getFormInput } from '@/utils/form-input-helper';
import { ISitecoreFormGenericInput } from '@/interfaces';
import FormStepInputs from '@/components/FormStepInputs/FormStepInputs.vue';
import ProductCardList from '@/components/ProductCardList/ProductCardList.vue';
import { useAccountStore } from '@/store';
import { PageAnalyticsBuilder } from '@/utils/page-analytics-builder';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  content: ISitecoreFormGenericInput[];
  id: string;
  name: string;
}>();

const accountStore = useAccountStore();
const yourProducts = ref(getFormInput(props.content, 'yourProducts'));
const dictionary = useI18n().getLocaleMessage('en') as Record<string, string>;

onMounted(() => {
  pushAnalytics();
});

const pushAnalytics = async () => {
  const pageAnalytics = new PageAnalyticsBuilder();
  pageAnalytics.populateProducts(dictionary);
  pageAnalytics.pushAnalytics();
};
</script>
